(function() {
    'use strict';

    angular
        .module('ipmApp')
        .controller('WellnessQuestionController', WellnessQuestionController);

    WellnessQuestionController.$inject = ['$scope', '$state', 'Question', 'WellnessQuestion', 'ParseLinks', 'pagingParams', 'paginationConstants'];

    function WellnessQuestionController ($scope, $state, Question, WellnessQuestion, ParseLinks, pagingParams, paginationConstants) {
        var vm = this;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.searchQuery = pagingParams.searchKey;
        vm.currentSearch = pagingParams.searchKey;
        vm.pageSize = 20;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;

        vm.loadAll();

        function loadAll () {
            WellnessQuestion.query({
                searchKey: pagingParams.searchKey,
                page: pagingParams.page - 1,
                size: paginationConstants.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.questions = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                //AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                searchKey: vm.currentSearch
            });
        }

        function search (searchKey) {
            if (!searchKey){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = searchKey;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = false;
            vm.currentSearch = '';
            vm.transition();
        }
    }
})();
